import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Suppress annoying WebSocket connection errors from webpack-dev-server
// These occur because the dev server tries to connect even when HMR/liveReload are disabled
if (!environment.production) {
  const originalError = console.error;
  console.error = function(...args: unknown[]) {
    const message = args[0]?.toString() || '';
    // Filter out webpack-dev-server WebSocket connection errors
    if (message.includes('WebSocket connection to') && 
        (message.includes('ng-cli-ws') || message.includes('webpack-dev-server'))) {
      return; // Suppress this error
    }
    originalError.apply(console, args);
  };
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
